import { ReactNode } from 'react';

export interface IFormFieldProps {
  basic?: boolean;
  buttonDisabled?: boolean;
  buttonText?: string;
  children?: ReactNode;
  className?: string;
  description?: string;
  disabled?: boolean;
  error?: boolean | string;
  inputClassName?: string;
  inputImg?: string;
  inputWrapClassName?: string;
  label?: string;
  labelAfter?: string;
  labelClassName?: string;
  leftIcon?: ReactNode;
  placeholder?: string;
  rightIcon?: ReactNode;
  scrollIntoView?: boolean;
  showButton?: boolean;
  tooltip?: string;
  hideInfoCheck?: boolean;
  info?: string;
  warning?: string;
  name: string;
  value: any;
  onBlur?(event: { target: any; type?: any }): void;
  onButtonClick?(): void;
  onChange?(event: { target: any; type?: any }): void;
}

export const CURRENT_YEAR = new Date().getFullYear();
export const MAX_PROP_CURRENT_YEAR = 'CURRENT_YEAR';
export const YEAR_LABEL = 'Year';
export const MAX_YEAR_DIGITS = 4;
